module.exports = "/_next/static/images/709d6203a237f7195e14f95b8a3e778c-nubanker-pm@0.5x.jpg";